// extracted by mini-css-extract-plugin
module.exports = {"heading":"Languages_heading__2KBLe","Languages":"Languages_Languages__2YZRA","row":"Languages_row__2RRfF"};